import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'edenred-ui';
import Moment from 'moment';

import { IMassUploadSummary } from '@epi-models/pages/MassUploadDetails';
import { importDateFormat } from '@epi-constants/dateFormats';
import { mapMassUploadStatusToNumber } from '@epi-models/pages/MassUpload';

import {
  SummaryWrapper,
  SummaryBox,
  SummaryLabel,
  SummaryValue,
  StatusBadge,
  StatusWrapper
} from '../MassUploadDetails.styles';

interface OwnProps {
  summary: IMassUploadSummary;
}

export const MassUploadDetailsSummary = ({ summary }: OwnProps) => {
  const { t } = useTranslation();

  const formatDate = (dateString: string) => {
    if (!dateString) return '-';
    return Moment(dateString).format(importDateFormat);
  };

  return (
    <SummaryWrapper>
      <SummaryBox>
        <SummaryLabel>
          {t('containers.mass_upload.details.summary.request_created')}
        </SummaryLabel>
        <SummaryValue>{formatDate(summary.requestCreated)}</SummaryValue>
      </SummaryBox>
      <SummaryBox>
        <SummaryLabel>
          {t('containers.mass_upload.details.summary.status_updated')}
        </SummaryLabel>
        <SummaryValue>{formatDate(summary.requestStatusUpdate)}</SummaryValue>
      </SummaryBox>
      <SummaryBox>
        <SummaryLabel>
          {t('containers.mass_upload.details.summary.employee_amount')}
        </SummaryLabel>
        <SummaryValue>{summary.totalCount}</SummaryValue>
      </SummaryBox>

      <SummaryBox>
        <SummaryLabel>
          {t('containers.mass_upload.details.summary.employees_created')}
        </SummaryLabel>
        <SummaryValue>{summary.created}</SummaryValue>
      </SummaryBox>
      <SummaryBox>
        <SummaryLabel>
          {t('containers.mass_upload.details.summary.employees_updated')}
        </SummaryLabel>
        <SummaryValue>{summary.updated}</SummaryValue>
      </SummaryBox>
      <SummaryBox>
        <SummaryLabel>
          {t('containers.mass_upload.details.summary.no_changes')}
        </SummaryLabel>
        <SummaryValue>{summary.unchanged}</SummaryValue>
      </SummaryBox>
      <SummaryBox>
        <SummaryLabel>
          {t('containers.mass_upload.details.summary.update_failed')}
        </SummaryLabel>
        <SummaryValue isError={summary.failed > 0}>
          {summary.failed}
        </SummaryValue>
      </SummaryBox>
      <SummaryBox>
        <SummaryLabel>
          {t('containers.mass_upload.details.summary.status')}
        </SummaryLabel>
        <SummaryValue>
          <StatusWrapper>
            <StatusBadge status={summary.status}></StatusBadge>
            <Box>
              {t(
                `containers.mass_upload.history_status.${mapMassUploadStatusToNumber(
                  summary.status
                )}`
              )}
            </Box>
          </StatusWrapper>
        </SummaryValue>
      </SummaryBox>
    </SummaryWrapper>
  );
};
